export const SET_FIRST_NAME = 'set-first-name';
export const SET_EMAIL = 'set-email';
export const SET_LAST_NAME = 'set-last-name';
export const SET_PHONE = 'set-phone';
export const SET_COMPANY = 'set-company';
export const SET_ROLE = 'set-role';
export const SET_MESSAGE = 'set-message';
